import React, { useState } from "react";
import { fetchColleges } from "./mockapi"; // Simulated API
import MultiSelectDropdown from "./draganddrop";
import InfoSection from "./informationsection/informationsection";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_COLLEGE_LIST } from "../../graphql/queries";
import { College } from "./types";

interface CollegeDropdownProps {
  onSelectionChange: (selected: { id: string; label: string; order: number; city: string; state: string; value: string }[]) => void;
  selectedColleges: College[];
  setIsSessionTimeOut: React.Dispatch<React.SetStateAction<boolean>>;
  showNotification: (message: string) => void;
  setSelectedColleges: React.Dispatch<React.SetStateAction<College[]>>;
}

const CollegeDropdown: React.FC<CollegeDropdownProps> = ({ onSelectionChange, selectedColleges, setSelectedColleges, setIsSessionTimeOut, showNotification }) => {
  const [getCollegeList, { data: collegeList }] = useLazyQuery(GET_COLLEGE_LIST);
  // Fetch colleges when the user types 3+ characters
  const handleSearch = async (search: string): Promise<College[]> => {
    if (search.length < 3) return [];
    try {
      const data = await getCollegeList({
        variables: {
          institutionSearchInput: {
            searchString: search,
            keyType: "COLLEGE CODE",
          },
        },
      });

      if (data?.errors?.length) {
        const isUnauthroized = data.errors.some(error => error.message === 'Unauthorized');
        if (isUnauthroized) {
          showNotification("Session time out. Please validate the student code once again.");
          setIsSessionTimeOut(true);
          return [];
        }
      }
      if (!data?.data?.institutions) {
        return [];
      }

      const formattedData = data.data.institutions.map((college: any) => ({
        id: college.keyValue,
        value: college.keyValue,
        label: college.reportingName,
        city: college.city,
        state: college.stateProvince,
      }));

      //console.log("formattedData:", formattedData);
      return formattedData;
    } catch (err: unknown) {
      if (err instanceof Error) {
        if (err.message.includes("Unauthorized")) {
          showNotification("Session time out. Please validate the student code once again.");
          setIsSessionTimeOut(true);
          return [];
        } 
      }
      return [];
    }
  };

  // Handle adding/updating selected colleges (limit to 4)
  const handleSelectChange = (selected: College[]) => {
    const limitedSelection = selected.slice(0, 4);
    setSelectedColleges(limitedSelection);
  };

  // Remove a college from the selected list
  const handleRemove = (id: string) => {
    const updatedSelection = selectedColleges.filter((college) => college.id !== id);
    setSelectedColleges(updatedSelection);
  };


  return (
    <div>
      <h2 aria-label="Select Colleges and Send Scores">Select Colleges and Send Scores</h2>
      <InfoSection message="You can search and select up to 4 colleges. Their order can be changed with drag and drop." />
      <MultiSelectDropdown
        // options={[]} // Not used here since AsyncSelect fetches data dynamically
        selectedColleges={selectedColleges}
        handleSelectChange={handleSelectChange}
        handleSearch={handleSearch}
        handleRemove={handleRemove}
      />
    </div>
  );
};

export default CollegeDropdown;
